export default {
    data: () => ({
        abstractOrders: null
    }),

    mounted() {
        this.abstractOrders = this.getAbstractOrderObjects(this.orders);
    },

    methods: {
        getAbstractOrderObjects(orders) {
            let abstractOrders = new Array();

            class OrderItem {
                constructor(id, title, images, categories) {
                    this.ID = id;
                    this.title = title;
                    this.image = images;
                    this.categories = categories;
                }
            }

            if (orders.activities != null && orders.activities.length > 0) {
                orders.activities.forEach(function (a) {
                    abstractOrders.push(new OrderItem(a.id, a.title.rendered, a.acf.content.images[0], ["Activiteit"]));
                })
            }

            if (orders.locations != null && orders.locations.length > 0) {
                orders.locations.forEach(function (l) {
                    abstractOrders.push(new OrderItem(l.id, l.title.rendered, l.acf.image, ["Locactie"]));
                })
            }

            if (orders.speakers != null && orders.speakers.length > 0) {
                orders.speakers.forEach(function (s) {
                    abstractOrders.push(new OrderItem(s.id, s.title.rendered, s.acf.image, ["Spreker"]));
                })
            }

            if (orders.staticItems != null && orders.staticItems.length > 0) {
                orders.staticItems.forEach(function (s) {
                    abstractOrders.push(new OrderItem(s.id, s.title.rendered, s.acf.image, ["Extra"]));
                })
            }

            if (orders.gifts != null && orders.gifts.length > 0) {
                orders.gifts.forEach(function (s) {
                    abstractOrders.push(new OrderItem(s.id, s.title.rendered, s.acf.image, ["Gift"]));
                })
            }

            if (orders.tribeBoxes != null && orders.tribeBoxes.length > 0) {
                orders.tribeBoxes.forEach(function (s) {
                    abstractOrders.push(new OrderItem(s.id, (s.title != null ? s.title.rendered : s.post_title), s.acf.image, ["Tribe Box"]));
                })
            }

            return abstractOrders;
        }
    }
}
